import { type MotionValue } from 'motion/react'
import { observer } from 'mobx-react-lite'
import { type JobListViewModel } from '@/features/jobs/details/components/JobList/JobListViewModel'
import {
  SplitViewHeader,
  SplitViewHeaderSearch,
} from '@/components/SplitView/SplitViewHeader'

export interface JobListHeaderContainerProps {
  vm: JobListViewModel
  scrollOffset: MotionValue<number>
}

export const JobListHeaderContainer = observer(function JobListHeaderContainer({
  vm,
  scrollOffset,
}: JobListHeaderContainerProps) {
  return (
    <SplitViewHeader compact scrollOffset={scrollOffset}>
      <SplitViewHeaderSearch
        onChange={vm.search}
        value={vm.searcher.searchText.value}
        placeholder="Search Jobs"
      />
    </SplitViewHeader>
  )
})
